import { render, staticRenderFns } from "./TepAutorizacionEstado.vue?vue&type=template&id=71a62ace"
import script from "./TepAutorizacionEstado.vue?vue&type=script&lang=js"
export * from "./TepAutorizacionEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports